import { render, staticRenderFns } from "./AcertoDespesaItemManage.vue?vue&type=template&id=23d3a38c&scoped=true"
import script from "./AcertoDespesaItemManage.vue?vue&type=script&lang=js"
export * from "./AcertoDespesaItemManage.vue?vue&type=script&lang=js"
import style0 from "./AcertoDespesaItemManage.vue?vue&type=style&index=0&id=23d3a38c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d3a38c",
  null
  
)

export default component.exports